// src/hooks/useChefEtablissement.js
import { useApi } from './useApi';
import { url } from '../../utils/confserveur';
export const useChefEtablissement = (etablissementId) => {

  const urlfetch = etablissementId ? `${url}chef/?etablissement=${etablissementId}` : url+'chef/';

  return useApi(urlfetch, []);
};